import { Trans } from "@lingui/react/macro";
import React from "react";
import {
  DescriptionTextColumnContent,
  DescriptionTextColumnContentLeft,
  DescriptionTextColumnContentRight,
  DescriptionTextColumnTitle,
  SectionContainer,
  DescriptionTextColumn,
  ButtonsContainer
} from "@silversea-ssc/ui-components-react";
import { CruiseQuery } from "types/graphql-types";
import CruiseItineraryPortsSummary from "src/page-components/cruise/CruiseItineraryPortsSummary/CruiseItineraryPortsSummary";
import { getGeoAreaStats } from "src/utils/cruise";
import { SlideshowItem } from "components/Slideshow/Slideshow";
import TextBox from "components/TextBox/TextBox";
import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";
import { NewEcommerceButton } from "components/ECommerceButtons";
const ResponsiveSlideshow = React.lazy(
  () => import("components/Slideshow/ResponsiveSlideshow")
);
import * as styles from "./SectionItineraryContent.module.scss";

interface CruiseSectionItineraryContentProps {
  cruise: CruiseQuery["cruise"];
  hasExcursions: boolean;
  slideshow: SlideshowItem[];
  showVSPreSaleMessage: boolean;
  ecommerceStatus?: ECommerceStatus;
}

const CruiseSectionItineraryContent: React.FC<
  React.PropsWithChildren<CruiseSectionItineraryContentProps>
> = ({
  cruise,
  hasExcursions,
  slideshow,
  showVSPreSaleMessage = false,
  ecommerceStatus
}) => {
  const { portsCount, countriesCount } = getGeoAreaStats(
    cruise?.data?.itinerary || []
  );

  return (
    <SectionContainer
      spacingTop="regular"
      spacingBottom="regular"
      backgroundColor="productTypeColor02"
      dataContentName="section_itinerary_content"
      className={styles.itinerarySectionSpacingTop}
    >
      <DescriptionTextColumn>
        <DescriptionTextColumnContent>
          <DescriptionTextColumnContentLeft>
            <DescriptionTextColumnTitle>
              {hasExcursions && <Trans>Itinerary & Excursions</Trans>}
              {!hasExcursions && <Trans>Itinerary</Trans>}
            </DescriptionTextColumnTitle>
            <CruiseItineraryPortsSummary
              ports={portsCount}
              countries={countriesCount}
            />
            {showVSPreSaleMessage && (
              <strong>
                <Trans id="message-pre-sale-for-VS-members">
                  Pre-sale is open to Venetian Society members.
                </Trans>
                <br />
                <br />
              </strong>
            )}
            <TextBox
              fontSize="medium"
              content={cruise?.itineraryDescription?.localized}
            />

            <ButtonsContainer spacingTop="regular" align="left">
              <NewEcommerceButton
                disableRAQ
                url={ecommerceStatus}
                raqUrl={undefined}
                size="regular"
                overrideEcommerceLabel={<Trans>Book this cruise</Trans>}
              />
            </ButtonsContainer>
          </DescriptionTextColumnContentLeft>
          <DescriptionTextColumnContentRight>
            {slideshow?.length > 0 && (
              <React.Suspense>
                <ResponsiveSlideshow
                  items={slideshow}
                  variant="white"
                  dataContentName="slideshow"
                />
              </React.Suspense>
            )}
          </DescriptionTextColumnContentRight>
        </DescriptionTextColumnContent>
      </DescriptionTextColumn>
    </SectionContainer>
  );
};

export default React.memo(CruiseSectionItineraryContent);
